import React, { useEffect, useState } from "react";
import styles from "./StoreNameBanner.module.css";
import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { getData } from "../../Hooks/apiCalls";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { isDevelopment } from "../../Hooks/constants";
import {
  setNewDownloadVersion,
  setStoreNameText,
  setVersionDate,
} from "../../Store/Dashboard/dashboardStore";
import Cookies from "js-cookie";
import { setTokenErr } from "../../Store/Common/commonStore";

const StoreNameBanner = () => {
  const loc = Cookies.get("ssp_loc") || "";
  const dispatch = useDispatch();
  const [storeName, setStoreName] = useState("");

  const getStoreName = async () => {
    let { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getLocDetails?loc=${loc}`,
      true
    );

    if (data.status === "success") {
      setStoreName(data.data[0].loc_name);
      dispatch(setVersionDate(data.data[0].version_date));
      dispatch(setNewDownloadVersion(data.data[0].new_version));
      dispatch(setStoreNameText(data.data[0].loc_name));
    } else {
      toast.error("Failed to load the location name", {
        autoClose: 1500,
      });
      dispatch(setTokenErr(true));
      window.close();
    }
  };
  useEffect(() => {
    if (loc !== undefined) {
      getStoreName();
    }
  }, [loc]);
  return (
    <Typography className={styles.mainDiv}>
      Location:
      <Box component="span" ml={2} className={styles.store}>
        {loc} {storeName}
      </Box>
    </Typography>
  );
};

export default StoreNameBanner;
